import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_203_6152)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_203_6152",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 25,
			children: /* @__PURE__ */ _jsx("rect", {
				y: .218994,
				width: 24,
				height: 24,
				fill: "currentColor"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_203_6152)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M6.09802 17.2861C6.99802 16.6721 7.93653 16.2157 8.91353 15.9169C9.89036 15.6182 10.9192 15.4689 12 15.4689C13.0809 15.4689 14.1097 15.6182 15.0865 15.9169C16.0635 16.2157 17.002 16.6721 17.902 17.2861C18.5237 16.6028 18.9954 15.8285 19.3173 14.9631C19.6391 14.0978 19.8 13.1831 19.8 12.2189C19.8 10.0577 19.0398 8.2174 17.5193 6.6979C15.9988 5.17856 14.1571 4.4189 11.9943 4.4189C9.83144 4.4189 7.99169 5.17856 6.47502 6.6979C4.95836 8.2174 4.20002 10.0577 4.20002 12.2189C4.20002 13.1831 4.36094 14.0978 4.68277 14.9631C5.00461 15.8285 5.47636 16.6028 6.09802 17.2861ZM12.0003 13.7689C11.0706 13.7689 10.2799 13.4431 9.62802 12.7914C8.97602 12.1396 8.65002 11.3488 8.65002 10.4191C8.65002 9.48948 8.97586 8.69873 9.62752 8.0469C10.2794 7.3949 11.0701 7.0689 11.9998 7.0689C12.9294 7.0689 13.7202 7.39473 14.372 8.0464C15.024 8.69823 15.35 9.48898 15.35 10.4186C15.35 11.3483 15.0242 12.1391 14.3725 12.7909C13.7207 13.4429 12.9299 13.7689 12.0003 13.7689ZM12.007 21.3189C10.7499 21.3189 9.56836 21.0833 8.46252 20.6121C7.35669 20.141 6.38877 19.4903 5.55877 18.6601C4.72861 17.8301 4.07794 16.8626 3.60677 15.7574C3.13561 14.6524 2.90002 13.4691 2.90002 12.2074C2.90002 10.9459 3.13561 9.7664 3.60677 8.6689C4.07794 7.5714 4.72861 6.60765 5.55877 5.77765C6.38877 4.94748 7.35636 4.29681 8.46152 3.82565C9.56652 3.35448 10.7499 3.1189 12.0115 3.1189C13.273 3.1189 14.4525 3.35448 15.55 3.82565C16.6475 4.29681 17.6113 4.94748 18.4413 5.77765C19.2714 6.60765 19.9221 7.57323 20.3933 8.6744C20.8644 9.77573 21.1 10.9549 21.1 12.2119C21.1 13.4691 20.8644 14.6506 20.3933 15.7564C19.9221 16.8622 19.2714 17.8301 18.4413 18.6601C17.6113 19.4903 16.6457 20.141 15.5445 20.6121C14.4432 21.0833 13.264 21.3189 12.007 21.3189ZM12 20.0189C12.8859 20.0189 13.756 19.8654 14.6105 19.5584C15.465 19.2512 16.2423 18.8118 16.9423 18.2401C16.2256 17.7708 15.4497 17.4083 14.6145 17.1526C13.7792 16.8968 12.9077 16.7689 12 16.7689C11.0924 16.7689 10.2151 16.891 9.36828 17.1351C8.52144 17.3795 7.75127 17.7478 7.05777 18.2401C7.75777 18.8118 8.53502 19.2512 9.38952 19.5584C10.244 19.8654 11.1142 20.0189 12 20.0189ZM12 12.4689C12.5642 12.4689 13.0469 12.2682 13.448 11.8669C13.8494 11.4657 14.05 10.9831 14.05 10.4189C14.05 9.85473 13.8494 9.37206 13.448 8.9709C13.0469 8.56956 12.5642 8.3689 12 8.3689C11.4359 8.3689 10.9532 8.56956 10.552 8.9709C10.1507 9.37206 9.95002 9.85473 9.95002 10.4189C9.95002 10.9831 10.1507 11.4657 10.552 11.8669C10.9532 12.2682 11.4359 12.4689 12 12.4689Z",
				fill: "currentColor"
			})
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_203_6152",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor",
			transform: "translate(0 0.218994)"
		})
	}) })]
});
export default SvgProfile;
